export const OUTLOOK_AUTO_SAVE_WORKSPACE_KEY = 'outlookAutoSaveWorkspace';

export interface OutlookAutoSaveWorkspace {
  userId: string;
  clientId: string;
  workspaceId: number;
}

export interface OutlookAutoSaveParticipant {
  email: string;
  name?: string;
}

export interface OutlookAutoSaveRequest {
  capturedAtUtc: string;
  exchangeMailId?: string;
  internetMessageId?: string;
  subject: string | null;
  bodyHtml: string;
  from: OutlookAutoSaveParticipant;
  to: OutlookAutoSaveParticipant[];
  cc: OutlookAutoSaveParticipant[];
  bcc: OutlookAutoSaveParticipant[];
  attachments: { id: string; fileName: string }[];
}

export interface OutlookAutoSaveResponse {
  status: 'Saved' | 'NeedsReview' | 'NoMatchingContacts' | 'Disabled';
  communicationId: number | null;
  emailSaved: boolean;
  attachmentsSaved: boolean;
  contactsNeedingReview: { email: string }[];
  attachments: { id: string; fileName: string; fileId: number | null; error?: string | null }[];
}

export const OUTLOOK_AUTO_SAVE_LIMITS = {
  attachments: 10,
  attachmentBytes: 10_000_000,
  requestBytes: 64_000_000,
  bodyCharacters: 500_000,
  subjectCharacters: 255,
  recipients: 500,
  formCharacters: 3_000_000,
};
